import { render, staticRenderFns } from "./CommissionSolshareFailed.vue?vue&type=template&id=6bafeaf2&scoped=true"
import script from "./CommissionSolshareFailed.vue?vue&type=script&lang=js"
export * from "./CommissionSolshareFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bafeaf2",
  null
  
)

export default component.exports